"use client";

import React from "react";
import Navbar from "@/components/Navbar";
import Footer2 from "@/components/landing-page/Footer2";

export default function PrivacyPage() {
    return (
        <>
            <Navbar isLoggedIn={false} />
            <div className="bg-zinc-950 min-h-screen text-white pt-32 pb-20">
                <div className="max-w-3xl mx-auto px-6">
                    <h1 className="text-3xl md:text-4xl font-bold mb-8">Privacy Policy</h1>
                    <div className="prose prose-invert prose-zinc text-zinc-400">
                        <p className="text-sm text-zinc-500 mb-8">Last Updated: January 1, 2026</p>

                        <h3>1. Information We Collect</h3>
                        <p>We collect information you provide directly to us, such as when you create an account, subscribe to our newsletter, or request customer support.</p>

                        <h3>2. How We Use Your Information</h3>
                        <p>We use the information we collect to provide, maintain, and improve our services, to develop new ones, and to protect Senera Core and our users.</p>

                        <h3>3. Data Security</h3>
                        <p>We implement reasonable security measures to help protect the security of your information both online and offline.</p>

                        <h3>4. Data Sharing</h3>
                        <p>We do not share your personal information with third parties except as described in this policy.</p>

                        <h3>5. Your Rights</h3>
                        <p>You have the right to access, correct, or delete your personal information. You can do this by logging into your account or contacting us.</p>
                    </div>
                </div>
            </div>
            <Footer2 />
        </>
    );
}
